<div class="container col-sm-8 pt-5 webview text-center" [@flyInOut]="'in'">
  <h1 class="text-center font-weight-normal-calibre pb-4 questxt">
    {{ question }}
  </h1>
  <div class="container-fluid px-0 text-center">
    <div class="col-md-8 offset-md-2 px-0">
      <div class="col-md-12 mb-2 px-0" *ngIf="showMap">
        <agm-map
          [latitude]="lat"
          [longitude]="lng"
          [zoomControl]="false"
          [disableDoubleClickZoom]="true"
          [zoom]="18"
          [scrollwheel]="false"
          [streetViewControl]="false"
        >
          <agm-marker
            [latitude]="lat"
            [longitude]="lng"
            [iconUrl]="markerIconUrl()"
          ></agm-marker>
        </agm-map>
      </div>
      <div class="row">
        <div class="col-sm-9">
          <!-- <label for="autocomplete">Enter your address</label> -->
          <input
            ngx-google-places-autocomplete
            [options]="options"
            #placesRef="ngx-places"
            (ngModelChange)="setFlag()"
            (keydown.space)="formatedAddress ? null : $event.preventDefault()"
            (onAddressChange)="handleAddressChange($event)"
            type="text"
            id="autocomplete"
            class="form-control"
            placeholder="Street address, City, State"
            [(ngModel)]="formatedAddress"
          />
        </div>
        <div class="col-sm-3">
          <input
            name="Apartment"
            id="mob_unit"
            #apt
            class="form-control"
            (change)="getAprtment($event)"
            type="text"
            placeholder="Unit"
            [(ngModel)]="apartment"
          />
        </div>
      </div>
      <br />
    </div>
    <div class="row">
      <div class="col-sm-12">
        <button
          class="btn next mr-2 ml-2 disabledButton mt-4 font22 text-uppercase"
          [ngClass]="{ sectbtn: isAddressSelected }"
          (click)="next()"
        >
          Next
        </button>
      </div>
    </div>
  </div>
</div>
<div class="container mobileview mt-4 px-0" [attr.id]="questionObj._id">
  <div class="d-flex h-100 row col-sm-12 pr-0">
    <div class="justify-content-center align-self-center col-sm-3 col-3 pl-0">
      <img style="width: 100%" src="assets/images/signimg.jpg" />
    </div>
    <div class="col-sm-9 col-9 px-0 my-auto">
      <div class="arrow_box">
        <h1 class="questionMob text-left">{{ question }}</h1>
      </div>
    </div>
  </div>
  <div class="container mt-2">
    <div class="col-12 mb-2 px-0" *ngIf="showMap">
      <agm-map
        [latitude]="lat"
        [longitude]="lng"
        [zoomControl]="false"
        [disableDoubleClickZoom]="true"
        [zoom]="15"
        [scrollwheel]="false"
        [streetViewControl]="false"
      >
        <agm-marker
          [latitude]="lat"
          [longitude]="lng"
          [iconUrl]="markerIconUrl()"
        ></agm-marker>
      </agm-map>
    </div>
  </div>
  <div class="row col-sm-12 m-auto px-0">
    <div class="col-12">
      <form #f="ngForm" (ngSubmit)="next()" novalidate>
        <input
          ngx-google-places-autocomplete
          [options]="options"
          #placesRef="ngx-places"
          (ngModelChange)="setFlag()"
          (keydown.space)="formatedAddress ? null : $event.preventDefault()"
          (onAddressChange)="handleAddressChange($event)"
          type="text"
          id="autocomplete"
          name="address"
          class="form-control"
          placeholder="Street address, City, State"
          [(ngModel)]="formatedAddress"
          (keyup.enter)="next()"
          (focusout)="next()"
        />
      </form>
    </div>
    <br />
    <br />
    <div class="col-12">
      <form #f="ngForm" (ngSubmit)="next()" novalidate>
        <input
          name="Apartment"
          id="unit"
          #apt_mob
          class="form-control"
          type="text"
          placeholder="Unit"
          (keydown.space)="apartment ? null : $event.preventDefault()"
          [(ngModel)]="apartment"
          (focusout)="next()"
          (keyup.enter)="next()"
        />
      </form>
    </div>

    <br />
    <div class="col-12">
      <div style="width: 97% !important; text-align: right">
        <div
          *ngIf="user_bot && isAddressSelected"
          class="ash_box text-right mt-3"
        >
          <h1 class="ansMob text-right">{{ formatedAddress }}</h1>
          <h1 *ngIf="apartment" class="ansMob text-right">
            Apartment: {{ apartment }}
          </h1>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex h-100 row col-sm-12 pr-0" *ngIf="showTyping">
    <div class="justify-content-center align-self-center col-sm-3 col-3 pl-0">
      <img style="width: 100%" src="assets/images/signimg.jpg" />
    </div>
    <div class="col-sm-2 col-2 px-0 my-auto">
      <div class="arrow_box">
        <img
          class="p-2 pl-2 ml-1"
          src="assets/images/typing-animated-gif-4.gif"
        />
      </div>
    </div>
  </div>
</div>
<ng-template #template>
  <div class="modal-header py-0">
    <div class="col-12 text-right py-0 px-0">
      <button
        type="button"
        class="close pull-right borderNone closeModelAlign"
        aria-label="Close"
        (click)="onCloseHandled()"
      >
        <div _ngcontent-c5="" class="float-right mr-1 mt-1">
          <img src="assets/images/editchart-close.svg" width="17" />
        </div>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <h4 class="utility-modal-title font20 text-center text-uppercase">
      Multiple Utilities in {{ zipcode }}
    </h4>
    <p class="utility-sub-title font20 text-center">
      Please select your utility from the list below:
    </p>
    <div
      class="col-sm-12 mb-2"
      *ngFor="let utility of utilities; let i = index"
    >
      <div class="d-flex m-auto col-sm-12 col-md-12 col-xl-6">
        <div class="modal-cards w-100">
          <div
            class="card card-list pt-2 text-center"
            id="{{ utility.TdspName }}"
            (click)="selectUtility(utility.TdspName)"
            [ngClass]="{ 'active-select': i === 0 }"
          >
            <div class="d-flex m-auto col-sm-12 col-md-12 col-xl-6">
              <img
                src="{{ displayProviderImages(utility.TdspName) }}"
                height="50"
                class="mx-auto d-block"
              />
            </div>
            <label
              class="utility-sub-title font16"
              for="{{ utility.TdspName }}"
              >{{ utility.FriendlyName }}</label
            >
          </div>
        </div>
      </div>
    </div>
    <br />
    <div class="col-12 text-center">
      <p class="utility-sub-title font15" *ngIf="isAddressSelected">
        Thank you! Your utility selection is saved.
      </p>
      <button
        class="btn mr-2 ml-2 col-12 font-weight-bold-calibre contbtn text-uppercase"
        (click)="closeModalWithOutContact()"
      >
        Next
      </button>
    </div>
  </div>
</ng-template>
<ng-template #noservice>
  <div id="serviceunavialbe">
    <div class="modal-header pr-1 pt-1">
      <div class="col-12 text-right py-0 px-0">
        <button
          type="button"
          class="close pull-right borderNone closeModelAlign"
          aria-label="Close"
          (click)="onCloseHandled()"
        >
          <div _ngcontent-c5="" class="float-right mr-1 mt-1">
            <img src="assets/images/editchart-close.svg" width="17" />
          </div>
        </button>
      </div>
    </div>
    <div class="modal-body pt-0">
      <h4
        class="utility-modal-title font20 text-center text-uppercase"
        *ngIf="zipcode"
      >
        SERVICE IS UNAVAILABLE FOR {{ zipcode }}
      </h4>
      <h4
        class="utility-modal-title font20 text-center text-uppercase"
        *ngIf="!zipcode"
      >
        SERVICE IS UNAVAILABLE
      </h4>
      <p class="utility-sub-title font20">
        If it were up to us, we’d love to have you as our newest customer! We’re
        sorry that we don’t have a say in which areas are open to energy choice.
      </p>
      <p class="utility-sub-title font20">
        Check back with us in the future, we’d love to stay connected with you!
      </p>
      <p class="utility-sub-title font20">
        In the meantime, iIf you have a question, drop us a line and let us know
        how we can be of service.
      </p>
      <div class="col-12 text-center">
        <button
          class="btn mr-2 ml-2 col-12 font-weight-bold-calibre contbtn text-uppercase mb-3"
          (click)="closeModal()"
        >
          Help
        </button>
      </div>
      <p class="utility-sub-title font20">
        Who do you know that would like to help make this world a better,
        brighter place while finding a deal on energy? Please let them know
        about us!
      </p>
      <div class="sidebar-ftr">
        <ul class="list-inline mb-2">
          <li>
            <a
              href="https://www.facebook.com/honestgorilla1/"
              class="px-0"
              target="_blank"
              ><img src="assets/images/facebook-co.svg" width="48px"
            /></a>
          </li>
          <li>
            <a
              href="https://twitter.com/honestgorilla"
              class="px-0"
              target="_blank"
              ><img src="assets/images/twitter-co.svg" width="48px"
            /></a>
          </li>
          <li>
            <a
              href="https://www.instagram.com/honestgorilla_energy/ "
              class="px-0"
              target="_blank"
              ><img src="assets/images/instragram-co.svg" width="48px"
            /></a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #contact>
  <div class="modal-header pr-1 pt-1 px-0">
    <div class="col-12 text-right">
      <button
        type="button"
        class="close videoclose"
        data-dismiss="modal"
        aria-label="Close"
        (click)="closeContactModal(f)"
      >
        <div class="float-right mr-1 mt-1">
          <img src="assets/images/editchart-close.svg" width="20" />
        </div>
      </button>
    </div>
  </div>
  <div class="modal-body pt-0">
    <h1 class="text-center conthead font-weight-bold-calibre">
      HOW CAN WE SERVE YOU
    </h1>
    <form
      name="form"
      (ngSubmit)="send($event, f, f.form.valid, 'contactModal')"
      #f="ngForm"
      novalidate
    >
      <div class="service-modal px-5">
        <div class="bdy-sec pt-0">
          <div>
            <p class="sb-ttl font-weight-normal-calibre pb-3">
              Provide your contact details, state your question, and we'll get
              back to you
            </p>
          </div>
          <div class="form-group">
            <input
              type="text"
              class="form-control inputshadow"
              name="fullName"
              [(ngModel)]="userObj.fullName"
              (keydown.space)="
                userObj.fullName ? null : $event.preventDefault()
              "
              #fullName="ngModel"
              [ngClass]="{ 'is-invalid': f.submitted && fullName.invalid }"
              placeholder="Full Name"
              required
            />
            <div
              *ngIf="f.submitted && fullName.invalid"
              class="invalid-feedback"
            >
              <div *ngIf="fullName.errors.required" class="boxcolour">
                <span
                  _ngcontent-c2=""
                  class="fa fa-exclamation-circle mr-1"
                  type="Icon"
                ></span
                >Full Name is required
              </div>
            </div>
          </div>
          <div class="form-group">
            <input
              type="text"
              class="form-control inputshadow"
              name="email"
              [(ngModel)]="userObj.emailId"
              (keydown.space)="userObj.emailId ? null : $event.preventDefault()"
              #email="ngModel"
              [ngClass]="{ 'is-invalid': f.submitted && email.invalid }"
              required
              email
              pattern="^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)\.*$"
              placeholder="Email Address"
            />
            <div *ngIf="f.submitted && email.invalid" class="invalid-feedback">
              <div class="boxcolour" *ngIf="email.errors.required">
                <span class="fa fa-exclamation-circle mr-1" type="Icon"></span
                >Email is required
              </div>
            </div>
            <div
              [hidden]="email.valid || email.pristine || !email.errors.pattern"
              class=""
            >
              <div class="boxcolour alertMsg">
                <span class="fa fa-exclamation-circle mr-1" type="Icon"></span
                >Please enter a valid email
              </div>
            </div>
          </div>
          <div class="form-group">
            <textarea
              type="text"
              class="form-control inputshadow removeResize"
              name="contactQues"
              [(ngModel)]="userObj.contactQues"
              (keydown.space)="
                userObj.contactQues ? null : $event.preventDefault()
              "
              #contactQues="ngModel"
              [ngClass]="{ 'is-invalid': f.submitted && contactQues.invalid }"
              placeholder="What's Your Burning Question?"
              required
            ></textarea>
            <div
              *ngIf="f.submitted && contactQues.invalid"
              class="invalid-feedback"
            >
              <div *ngIf="contactQues.errors.required" class="boxcolour">
                <span
                  _ngcontent-c2=""
                  class="fa fa-exclamation-circle mr-1"
                  type="Icon"
                ></span
                >Please enter a value
              </div>
            </div>
          </div>
          <div class="form-group float-label-control text-center mb-1 pt-2">
            <button
              class="btn mr-2 ml-2 col-12 font-weight-bold-calibre contbtn"
              data-backdrop="false"
            >
              SEND
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</ng-template>
<ng-template #thank>
  <div class="modal-header pr-1 pt-1 px-0">
    <div class="col-12 text-right">
      <button
        type="button"
        class="close videoclose"
        data-dismiss="modal"
        aria-label="Close"
        (click)="closeResetModal()"
      >
        <div class="float-right mr-1 mt-1">
          <img src="assets/images/editchart-close.svg" width="20" />
        </div>
      </button>
    </div>
  </div>
  <div class="modal-body pt-0">
    <div class="service-modal">
      <div class="bdy-sec">
        <div>
          <p class="sb-ttl resettxt text-center">
            Thank you! Your message has been sent. A member of our team will be
            in touch soon!
          </p>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<ngx-spinner></ngx-spinner>
<div class="backdrop" [ngStyle]="{ display: display }"></div>
<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{ display: display }">
  <div class="modal-dialog" role="document">
    <div class="modal-content m-auto blockbg boxclr text-center">
      <div class="modal-body">
        <div class="">
          <img src="assets/images/loading.gif" />
          <p class="text-center tipmes font15">
            Please wait for a few seconds...
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
